var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInternet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M20 9.5c5.8 0 10.5 4.701 10.5 10.5S25.8 30.5 20 30.5 9.5 25.8 9.5 20 14.201 9.5 20 9.5Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M20 9.5c2.927 0 5.3 4.701 5.3 10.5S22.927 30.5 20 30.5s-5.3-4.7-5.3-10.5S17.073 9.5 20 9.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9 26.7c1.9-1.1 4.9-1.9 8.1-1.9s6.1.7 8.1 1.9M28.2 13.2c-1.9 1.2-4.9 1.9-8.2 1.9-3.2.1-6.1-.7-8-1.8M9.5 20h21.1M20 9.5v21"
}))));
export default SvgInternet;